import type { OnPageTransitionEndAsync } from "vike/types";
import { pageQueryToPageDetails } from "@/utils/pageQueryToPageDetails";
import { parseQueryParamsFromUrl } from "@/utils/queryParams";
import { routerEventEmitter } from "@/services/router/routerEventEmitter";
import type { QueryParamsObj } from "@/types/UrlQueries";

export const onPageTransitionEnd: OnPageTransitionEndAsync = async (pageContext) => {
	const query = pageContext.query || parseQueryParamsFromUrl(pageContext.urlOriginal);
	const { internalPageName } = pageQueryToPageDetails(query as QueryParamsObj);
	console.info(`Page transition end: ${internalPageName}`);

	document.body.classList.remove("page-transitioning");

	routerEventEmitter.emit("TransitionEnd", pageContext.urlOriginal, internalPageName);
};
